// extracted by mini-css-extract-plugin
export var body = "Details-module--body--e5fa1";
export var container = "Details-module--container--81f5d";
export var detailsGroup = "Details-module--details-group--14421";
export var numbered = "Details-module--numbered--20a63";
export var summary = "Details-module--summary--6d68a";
export var summaryText = "Details-module--summary-text--9c908";